import React from 'react';
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({current = "/app", ...props}) => {

    return (
        <div className="min-h-screen flex flex-col">
            <Header current={current}/>
            <div className="w-full flex flex-col items-center flex-1 ">
                {props.children}
            </div>
            <Footer/>
        </div>
    );
}

export default Layout;
